export function withAppPerformancePage(Component: React.FC<any>) {
  function WithAppPerformancePage() {
    return <Component />
  }

  return WithAppPerformancePage
}
